<p class="text-center mt-4 mb-3">
  {{
    (isBlocking
      ? 'userManagement.block.confirmationMessageBlocked'
      : 'userManagement.block.confirmationMessageUnblocked'
    ) | translate
  }}
</p>

<div class="form-group px-4 mb-4">
  <label for="blockReason" class="form-label">
    {{
      (isBlocking
        ? 'userManagement.block.blockReasonLabel'
        : 'userManagement.block.unblockReasonLabel'
      ) | translate
    }}
    <span class="text-danger">*</span>
  </label>
  <textarea
    id="blockReason"
    class="form-control"
    rows="3"
    [(ngModel)]="reason"
    placeholder="{{
      (isBlocking
        ? 'userManagement.block.blockReasonPlaceholder'
        : 'userManagement.block.unblockReasonPlaceholder'
      ) | translate
    }}">
  </textarea>
  @if (!isReasonValid) {
    <small class="text-danger">{{ 'userManagement.block.reasonRequired' | translate }}</small>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="closeModal()">
    {{ 'btn.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-secondary" [disabled]="!isReasonValid" (click)="blockUser()">
    {{
      (isBlocking ? 'userManagement.block.blockUser' : 'userManagement.block.unblockUser')
        | translate
    }}
  </button>
</div>
